import { useEffect } from 'react';
import { useLayout } from '@/contexts/LayoutContext';
import { useTheme } from '@/contexts/ThemeContext';
import { getLayout6ThemeStyle, WL6_THEME_KEYS } from './theme';

/** Injeta variáveis WL6 no :root quando o layout 6 está ativo (evita reset por `.layout-6` aninhado). */
export function Layout6ThemeSync() {
  const { currentLayout } = useLayout();
  const { colors } = useTheme();

  useEffect(() => {
    const root = document.documentElement;
    const isLayout6 = currentLayout === 'layout-6';

    if (!isLayout6) {
      WL6_THEME_KEYS.forEach((key) => root.style.removeProperty(key));
      return;
    }

    const style = getLayout6ThemeStyle(colors);
    Object.entries(style).forEach(([key, value]) => {
      if (typeof value === 'string') {
        root.style.setProperty(key, value);
      }
    });

    return () => {
      WL6_THEME_KEYS.forEach((key) => root.style.removeProperty(key));
    };
  }, [currentLayout, colors]);

  return null;
}
